import { render, staticRenderFns } from "./WhatMakesFCCard.vue?vue&type=template&id=761b886e&scoped=true&"
import script from "./WhatMakesFCCard.vue?vue&type=script&lang=ts&"
export * from "./WhatMakesFCCard.vue?vue&type=script&lang=ts&"
import style0 from "./WhatMakesFCCard.vue?vue&type=style&index=0&id=761b886e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761b886e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
